/**
 * @todo we need to get these from a service and not hardcode them here
 */
export const CREDIT_MULTIPLIERS = {
  DATASET_ENRICHMENT: 10,
  SMART_PROPERTY_RUN: 10,
  INTENT_MONITORING: 5
};